<div class="dialog-container">
    <div class="dialog-body">
      <img
        [src]="images?.REMOVE_DISCOUNT"
        alt="delete"
      />
      <div class="p-2">
      <div class="title">{{ 'Remove Discount' | translate }}</div>
      <div class="description">
        {{ 'This will remove all the discount coupons from your order. Are you sure you want to proceed?' | translate }}
      </div>
    </div>
    <div class="dialog-footer flex_sb p-2">
      <button class="btn revert-btn" (click)="removeClicked()">
        {{ 'Yes' | translate }}
      </button>
      <button class="btn cancel-btn" (click)="cancelClicked()">
        {{ 'No' | translate }}
      </button>
    </div>
  </div>
</div>
  